import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
//import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import VideocamIcon from '@material-ui/icons/Videocam';
import VideocamOffIcon from '@material-ui/icons/VideocamOff';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VideoStatus from 'enums/VideoStatus';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import withStyles from '@material-ui/styles/withStyles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleRosterAttendeeMutedAction } from 'store/classroom/classroomActions';
import { sendMessageAction } from 'store/message/messageActions';
import { toggleVideoAction } from 'store/video/videoActions';
import has from 'lodash/has';

const RosterIconButton = withStyles(() => ({
  root: {
    padding: 3,
  },
}))(IconButton);

const useStyles = makeStyles((theme) => ({
  root: {
    margin: `0.75rem ${theme.sidePanel.gutter}`,
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.5rem 0',
    borderBottom: '2px solid #fff2',
  },
  userName: {
    flexGrow: 1,
    fontWeight: 'bold',
  },
  muteAllButton: {
    marginBottom: '2rem',
  },
}));

export default function Roster() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    meetingId,
    name,
    attendeeId,
    meetingSession,
    videoAttendees,
    roster,
    localVideoStatus,
  } = useSelector(({ video, chime }) => ({
    meetingId: chime.meetingId,
    attendeeId: chime.attendeeId,
    name: chime.name,
    roster: chime.roster,
    meetingSession: chime.meetingSession,
    videoAttendees: video.tileMap,
    localVideoStatus: video.videoStatus,
  }));

  const handleToggleMuteAttendee = (selectedRosterAttendeeId) => {
    dispatch(
      toggleRosterAttendeeMutedAction({
        selectedRosterAttendeeId,
      })
    );
  };

  const handleToggleVideo = (presenterAttendeeId, toggleRemoteAttendee) => {
    if (presenterAttendeeId === attendeeId) dispatch(toggleVideoAction());
    else
      dispatch(
        toggleVideoAction({
          presenterAttendeeId,
          toggleRemoteAttendee,
        })
      );
  };

  /*const kickUser = (selectedRosterAttendeeId) => {
    dispatch(
      sendMessageAction({
        type: 'remove',
        payload: {
          attendeeId: selectedRosterAttendeeId,
          meetingId,
          name,
        },
      })
    );
  };*/

  const muteAll = () => {
    dispatch(
      sendMessageAction({
        type: 'mute-all',
        payload: {
          attendeeId,
          meetingId,
          name,
        },
      })
    );
  };
  return (
    <div className={classes.root}>
      <Button
        fullWidth
        color="secondary"
        variant="contained"
        size="small"
        className={classes.muteAllButton}
        onClick={muteAll}
      >
        Mute All
      </Button>
      {meetingSession &&
        roster &&
        Object.entries(roster)
          .filter(([, attendee]) => !attendee.isRecordingUser && !!attendee.name)
          .sort(([, attendeeA], [, attendeeB]) => attendeeA.name - attendeeB.name)
          .map(([remoteAttendeeId, { name, muted }]) => {
            const isMe = remoteAttendeeId === attendeeId;
            const videoIsActive = isMe
              ? localVideoStatus === VideoStatus.Enabled
              : has(videoAttendees, remoteAttendeeId);
            const canToggleVideo = videoIsActive || isMe;
            const canToggleMute = !muted || isMe;

            return (
              <div className={classes.user} key={remoteAttendeeId}>
                <div className={classes.userName}>{name}</div>

                <RosterIconButton
                  onClick={() => handleToggleVideo(remoteAttendeeId, canToggleVideo)}
                  disabled={!canToggleVideo}
                >
                  {videoIsActive ? <VideocamIcon /> : <VideocamOffIcon />}
                </RosterIconButton>

                <RosterIconButton
                  onClick={() => handleToggleMuteAttendee(remoteAttendeeId)}
                  disabled={!canToggleMute}
                >
                  {!muted ? <VolumeUpIcon /> : <VolumeOffIcon />}
                </RosterIconButton>

                {/*<RosterIconButton onClick={() => kickUser(remoteAttendeeId)}>
                  <ExitToAppIcon />
                </RosterIconButton>*/}
              </div>
            );
          })}
    </div>
  );
}
